<h3>Total Billed Orders</h3>

<div class="card">
  <p-chart
    type="bar"
    [data]="data"
    [options]="options"
    (onDataSelect)="selectData($event)"
    [style.background-color]="bgColor"></p-chart>
</div>

<!-- <jni-modal-stacker
  *ngIf="orderListingDisplayModal"
  [displayModal]="orderListingDisplayModal"
  (closeEvent)="closeOrderListingModal()">
  <h1 class="panelHeading">Order Listing</h1>
  <div class="panelBody">
    <jni-orders [isAdditionalFilters]="true"></jni-orders>
  </div>
</jni-modal-stacker> -->
